import { render, staticRenderFns } from "./GBoothDisplayTypeForm.vue?vue&type=template&id=7c2da87a&scoped=true&"
import script from "./GBoothDisplayTypeForm.vue?vue&type=script&lang=ts&"
export * from "./GBoothDisplayTypeForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothDisplayTypeForm.vue?vue&type=style&index=0&id=7c2da87a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c2da87a",
  null
  
)

export default component.exports